import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useOpportunityStages } from '../useOpportunityStages.ts';

// Fills in this tenant's first stage once the list loads, leaving any existing
// choice alone.
export const DefaultOpportunityStage = () => {
  const { setValue } = useFormContext();
  const opportunityStageId = useWatch({ name: 'opportunityStageId' });
  const { firstStageId } = useOpportunityStages();

  useEffect(() => {
    if (opportunityStageId || !firstStageId) return;
    setValue('opportunityStageId', firstStageId);
  }, [opportunityStageId, firstStageId, setValue]);

  return null;
};
